import { Skeleton } from "@/components/ui/skeleton";

export function EssenceCardSkeleton({ lines = 5 }: { lines?: number }) {
  return (
    <div className="flex h-[420px] w-full flex-col gap-3 rounded-xl border border-line bg-[rgb(16_14_27/0.6)] px-5 pt-5 pb-5">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-24 rounded-full" />
        <Skeleton className="size-6 rounded-full" />
      </div>
      <Skeleton className="h-2.5 w-20 rounded-full" />
      <Skeleton className="h-5 w-3/4 rounded-md" />
      <div className="space-y-2 pt-1">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton
            key={i}
            className="h-3 rounded-full"
            style={{ width: `${92 - (i % 3) * 14}%` }}
          />
        ))}
      </div>
      <div className="mt-auto flex gap-1.5 pt-2">
        <Skeleton className="h-[20px] w-16 rounded-full" />
        <Skeleton className="h-[20px] w-12 rounded-full" />
      </div>
    </div>
  );
}

export function EssenceGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <EssenceCardSkeleton key={i} lines={4 + (i % 3)} />
      ))}
    </div>
  );
}

export function EssenceBrowserSkeleton() {
  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 py-5 sm:px-6 lg:py-8" aria-busy>
      <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
        <aside className="hidden w-[272px] shrink-0 lg:block">
          <Skeleton className="h-4 w-16 rounded-full" />
          <div className="mt-5 space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-10 rounded-lg" />
            ))}
          </div>
        </aside>
        <div className="min-w-0 flex-1 space-y-5">
          <Skeleton className="h-12 w-full rounded-full" />
          <Skeleton className="h-4 w-40 rounded-full" />
          <EssenceGridSkeleton />
        </div>
      </div>
    </div>
  );
}
